import { render, staticRenderFns } from "./update-account-preferences.vue?vue&type=template&id=9513db0a"
import script from "./update-account-preferences.vue?vue&type=script&lang=js"
export * from "./update-account-preferences.vue?vue&type=script&lang=js"
import style0 from "./update-account-preferences.vue?vue&type=style&index=0&id=9513db0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports